import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { applyBrand } from './config/brands';
import './index.css';

// Apply the active deployment's brand (colors / title / favicon) before render.
applyBrand();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker so the app is installable (PWA).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
